import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { ErrorButton, Dialog, Typography } from '@beeline.com/bp-design-system';
import { useCommonIntl } from 'src/components/common/translations/useCommonIntl';
import { useRateCardsIntl } from './translations/useRateCardsIntl';
interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}
export const DeleteRateCardDialog: FC<React.PropsWithChildren<Props>> = memo((props) => {
  const { onConfirm, onCancel, open } = props;
  const intl = useRateCardsIntl();
  const commonIntl = useCommonIntl();
  return (
    <Dialog
      show={{ cancelButton: true }}
      title={intl.deleteRateCard}
      subTitle=""
      open={open}
      onClose={onCancel}
      actions={[
        <StyledDeleteButton dataTest="delete__rate_card__button" onClick={onConfirm} key="confirm" size="medium">
          {commonIntl.commonDelete}
        </StyledDeleteButton>
      ]}
    >
      <Typography variant="body1">
        <div data-test="delete_rate_card_content">{intl.confirmContinue}</div>
      </Typography>
    </Dialog>
  );
});
const StyledDeleteButton = styled(ErrorButton.Contained)`
  min-height: 2.4rem !important;
  pointer-events: ${(props) => (props?.disabled ? 'none' : 'auto')} !important;
`;
